import { Pipe, PipeTransform } from "@angular/core";
import { __ } from "../functions/object.functions";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
    name: "time",
})
export class TimePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(value: number, type: "seconds" | "minutesAndSeconds" | "hoursAndMinutes" | "daysAndHours" | "minutesOnly"): string {
    if (__.IsNullOrUndefinedOrEmpty(value)) {
      return "";
    }
    switch (type) {
      case "seconds":
        return this.getSeconds(value);
      case "minutesAndSeconds":
        return this.getMinutesAndSeconds(value);
      case "minutesOnly":
        return this.getMinutesOnly(value);
      case "hoursAndMinutes":
        return this.getHoursAndMinutes(value);
      case "daysAndHours":
        return this.getDaysAndHours(value);
      default:
        return '';
    }
  }

  getSeconds(value: number): string {
    const seconds = Math.floor(value) || 0;

    return Math.trunc(seconds) + " " + this.translateService.instant("Hypecast Plugin.Seconds");
  }

  getMinutesAndSeconds(value: number): string {
    const minutes = Math.floor(value / 60) || 0;
    const seconds = value - minutes * 60 || 0;

    return (
      minutes +
      " " +
      this.translateService.instant("Hypecast Plugin.Minutes") +
      " " +
      Math.trunc(seconds) +
      " " +
      this.translateService.instant("Hypecast Plugin.Seconds")
    );
  }

  getMinutesOnly(value: number): string {
    const minutes = Math.round(value / 60) || 0;

    return minutes + " " + this.translateService.instant("Hypecast Plugin.Minutes");
  }

  getHoursAndMinutes(value: number): string {
    const hours = Math.floor(value / 3600) || 0;
    const minutes = (value - hours * 3600) / 60 || 0;

    return (
      hours +
      " " +
      this.translateService.instant("Hypecast Plugin.Hours") +
      " " +
      Math.trunc(minutes) +
      " " +
      this.translateService.instant("Hypecast Plugin.Minutes")
    );
  }

  getDaysAndHours(value: number): string {
    const days = Math.floor(value / 86400) || 0;
    const hours = (value - days * 86400) / 3600 || 0;

    return days + " days and " + Math.trunc(hours) + " hours";
  }
}
